<template>
    <div class="coming-soon-area">
        <div class="d-table">
            <div class="d-table-cell">
                <div class="coming-soon-content">
                    <div class="row align-items-center">
                        <div class="col-lg-3 col-sm-4">
                            <div id="timer" class="flex-wrap justify-content-center">
                                <div
                                    id="days"
                                    class="align-items-center flex-column d-flex justify-content-center"
                                >
                                    {{days}}
                                    <span>Days</span>
                                </div>
                                <div
                                    id="hours"
                                    class="align-items-center flex-column d-flex justify-content-center"
                                >
                                    {{hours}}
                                    <span>Hours</span>
                                </div>
                                <div
                                    id="minutes"
                                    class="align-items-center flex-column d-flex justify-content-center"
                                >
                                    {{minutes}}
                                    <span>Minutes</span>
                                </div>
                                <div
                                    id="seconds"
                                    class="align-items-center flex-column d-flex justify-content-center"
                                >
                                    {{seconds}}
                                    <span>Seconds</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-9 col-sm-8">
                            <div class="text-start">
                                <router-link to="/" class="mb-4 d-block">
                                    <img src="../../assets/images/main-logo.svg" alt="Image">
                                </router-link>
        
                                <h2>Coming Soon</h2>
                                
                                <form @submit.prevent class="newsletter-form" data-toggle="validator">
                                    <div class="form-group">
                                        <input type="email" class="input-newsletter" placeholder="Enter your email" name="EMAIL" required autocomplete="off">
                                    </div>
                                    
                                    <button type="submit" class="default-btn">
                                        Subscribe
                                    </button>
        
                                    <div id="validator-newsletter" class="form-result"></div>
                                    <p>If you would like to be notified when your app is live, Please subscribe to our mailing list.</p>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ComingSoonPage',
    data() {
        return {
            days: '',
            hours: '',
            minutes: '',
            seconds: ''
        }
    },
    created() { // Turn data into viewable values
        setInterval(() => {
            this.commingSoonTime();
        }, 1000);
    },
    methods: {
        commingSoonTime() {
            let endTime = new Date("December 5, 2025 17:00:00 PDT");            
            let endTimeParse = (Date.parse(endTime)) / 1000;
            let now = new Date();
            let nowParse = (Date.parse(now) / 1000);
            let timeLeft = endTimeParse - nowParse;
            let days = Math.floor(timeLeft / 86400);
            let hours = Math.floor((timeLeft - (days * 86400)) / 3600);
            let minutes = Math.floor((timeLeft - (days * 86400) - (hours * 3600 )) / 60);
            let seconds = Math.floor((timeLeft - (days * 86400) - (hours * 3600) - (minutes * 60)));
            if (hours < "10") { hours = "0" + hours; }
            if (minutes < "10") { minutes = "0" + minutes; }
            if (seconds < "10") { seconds = "0" + seconds; }
            this.days = days;
            this.hours = hours;
            this.minutes = minutes;
            this.seconds = seconds;
        }
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>

<style lang="scss">
.coming-soon-area {
	height: 100vh;
	background-image: url(../../assets/images/coming-soon-bg.png);
	background-position: center;
	background-repeat: no-repeat;
	background-size: cover;
}
.coming-soon-content {
	max-width: 700px;
	border-radius: 5px;
	overflow: hidden;
	text-align: center;
	padding: 60px;
	background-color: var(--white-color);
	box-shadow: var(--box-shadow);
	margin: auto;
	h2 {
		font-size: 40px;
		margin-top: -10px;
		margin-bottom: 0;
	}
	#timer {
		div {
			border: 2px solid var(--main-color);
			color: var(--main-color);
			width: 85px;
			height: 85px;
			border-radius: 5px;
			font-size: 30px;
			font-weight: 800;
			margin-left: 10px;
			margin-right: 10px;
			margin-bottom: 10px;
			&:last-child {
				margin-bottom: 0;
			}
			span {
				display: block;
				margin-top: -2px;
				font-size: 14px;
				font-weight: 600;
			}
		}
	}
	form {
		position: relative;
		max-width: 500px;
		margin-left: auto;
		margin-right: auto;
		margin-top: 30px;
		.form-group {
			margin-bottom: 25px;
			width: 100%;
			position: relative;
			.label-title {
				margin-bottom: 0;
				position: absolute;
				display: block;
				left: 0;
				top: 0;
				pointer-events: none;
				width: 100%;
				height: 100%;
				color: var(--heading-color);
				i {
					position: absolute;
					left: 0;
					transition: var(--transition);
					top: 9px;
					font-size: 22px;
				}
				&::before {
					content: "";
					display: block;
					position: absolute;
					bottom: 0;
					left: 0;
					width: 0;
					height: 2px;
					transition: var(--transition);
					background: var(--main-color);
				}
			}
			.input-newsletter {
				border-radius: 0;
				border: 1px solid #eeeeee;
				padding: 10px 20px;
				color: var(--heading-color);
				height: 50px;
				display: block;
				width: 100%;
				transition: var(--transition);
				font-size: 15px;
				font-weight: 400;
				background-color: var(--white-color);
				border-radius: 8px;
				&::placeholder {
					color: var(--body-color);
					transition: var(--transition);
				}
				&:focus {
					border-color: var(--main-color);
					outline: 0 !important;
					&::placeholder {
						color: transparent;
					}
				}
			}
		}
		.validation-danger {
			margin-top: 15px;
			color: #ff0000;
		}
		.validation-success {
			margin-top: 15px;
		}
		p {
			margin-bottom: 0;
			margin-top: 20px;
		}
	}
	.newsletter-form {
		.default-btn {
			margin-top: 0;
			position: absolute;
			top: 0;
			right: 0;
			height: 49px;
		}
	}
}
</style>